import React from 'react';
import {Helmet} from 'react-helmet';
import {CollectionIcon,LightningBoltIcon,GlobeAltIcon} from '@heroicons/react/outline';
import locales from '../../locales/locales';
import Translator from '../translator/translator';
import Navbar from '../navbar/navbar';
import Footer from '../footer/footer';
const TranslatorPage=({globalSettings})=>{
  return (
    <div className='min-h-screen flex flex-col bg-white'>
      <Helmet>
        <title>NekoTranslate - {locales.translatorPageTitle[globalSettings.lang]}</title>
      </Helmet>
      <Navbar 
        globalSettings={globalSettings}
      />
      <div className='flex-1 bg-purple-50 pt-16'>
        <div className='max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24'>
          <div className='text-center mb-12'>
            <h1 className='text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight'>
              {locales.translatorPageHeadingPrefix[globalSettings.lang]}
              <span className='text-purple-800'>
                {locales.translatorPageHeadingHighlight[globalSettings.lang]}
              </span>
              {locales.translatorPageHeadingSuffix[globalSettings.lang]}
            </h1>
            <p className='mt-4 text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto'>
              {locales.translatorPageDescription[globalSettings.lang]}
            </p>
          </div>
          <div className='grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8'>
            <div className='lg:col-span-2'>
              <Translator
                globalSettings={globalSettings}
              />
            </div>
            <div>
              <div className='bg-white p-6 rounded-xl shadow-lg border border-gray-200 mb-6'>
                <div className='h-12 w-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4'>
                  <LightningBoltIcon className='h-6 w-6 text-purple-800' />
                </div>
                <h3 className='text-xl font-semibold text-gray-900 mb-2'>
                  {locales.translatorPageFastProcessing[globalSettings.lang]}
                </h3>
                <p className='text-gray-600'>
                  {locales.translatorPageFastProcessingDesc[globalSettings.lang]}
                </p>
              </div>
              
              <div className='bg-white p-6 rounded-xl shadow-lg border border-gray-200 mb-6'>
                <div className='h-12 w-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4'>
                  <CollectionIcon className='h-6 w-6 text-purple-800' />
                </div>
                <h3 className='text-xl font-semibold text-gray-900 mb-2'>
                  {locales.translatorPageBulkTranslation[globalSettings.lang]}
                </h3>
                <p className='text-gray-600'>
                  {locales.translatorPageBulkTranslationDesc[globalSettings.lang]}
                </p>
              </div>
              <div className='bg-white p-6 rounded-xl shadow-lg border border-gray-200'>
                <div className='h-12 w-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4'>
                  <GlobeAltIcon className='h-6 w-6 text-purple-800' />
                </div>
                <h3 className='text-xl font-semibold text-gray-900 mb-2'>
                  {locales.translatorPageMultipleLanguages[globalSettings.lang]}
                </h3>
                <p className='text-gray-600'>
                  {locales.translatorPageMultipleLanguagesDesc[globalSettings.lang]}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer 
        globalSettings={globalSettings}
      />
    </div>
  );
};
export default TranslatorPage;

